export type Initializer = () => void;

const initialized = new Set<symbol>();

export const initOnce = (key: symbol, initializer: Initializer): void => {
  if (initialized.has(key)) {
    return;
  }
  initialized.add(key);
  initializer();
};
